<template>
  <form-wrapper :validator="$v.value">
    <!-- <div class="">Contact Details</div> -->
    <section class="content-body">
      <b-row>
        <b-col>
          <ContactInput refs="ContactInput" :data="contact" @saveContact="save" @clearContact="clear"
            :isFormDisabled="false" />
        </b-col>
        <b-col>
          <List @editContact="editContact" :data="value" />
        </b-col>
      </b-row>
    </section>
  </form-wrapper>
</template>

<script>
// Components
import ContactInput from "./Input";
import List from "./List";
// Models
import ContactModel from "@/models/ContactModel";

import lodash from "lodash";

export default {
  name: "Contact",
  components: {
    ContactInput,
    List,
  },
  data: () => ({
    contact: Object.assign({}, ContactModel),
    index: -1,
  }),
  props: {
    value: {
      type: Object,
      default: {},
    },
  },
  methods: {
    editContact(index) {
      this.index = index;
      const contact = this.value[index];
      this.contact = lodash.cloneDeep(contact);
      this.contact = Object.assign({}, contact);
      this.actionName = "Save";
    },
    save(contact) {
      if (this.index == -1) {
        this.value.push(contact);
      } else {
        let value = lodash.cloneDeep(this.value);
        value[this.index] = contact;
        this.value = value;
      }

      this.$emit("input", this.value);

      this.contact = Object.assign({}, ContactModel);
      this.$v.$reset();
    },
    clearValidations() {
      if (this.$refs.ContactInput) {
        this.$refs.ContactInput.clearValidations();
      }
    },
    clear() {
      this.contact = Object.assign({}, ContactModel);
    },
    isValid() {
      this.$v.$touch(); // it will validate all fields

      let status = false;

      if (status) {
        // invalid, becomes true when a validations return false
        return true;
      } else {
        return false;
      }
    },
    DateFormat(dob) {
      return formatDate(dob);
    },
  },
  validations: {
    value: {},
  },
};
</script>
